import { render, staticRenderFns } from "./WBUDPaintCell.vue?vue&type=template&id=160c73d4&scoped=true&"
import script from "./WBUDPaintCell.vue?vue&type=script&lang=js&"
export * from "./WBUDPaintCell.vue?vue&type=script&lang=js&"
import style0 from "./WBUDPaintCell.vue?vue&type=style&index=0&id=160c73d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160c73d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
